<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3.5">
                    <div class="text-center text-lg pb-5 pt-3">
                        <DefaultConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'default'" />
                    </div>
                    <div class="">
                        <div class="pb-7">
                            <button class="bg-primary-color text-secondary-color text-20 rounded-full w-full py-2.5 font-bold" @click="clickOk()">
                                {{btnOk}}
                            </button>
                        </div>
                        <div class="border-b border-im-gray-e9e8e8 w-full absolute left-0 right-0 m-auto"></div>
                        <div>
                            <button class="w-full text-im-gray-767676 text-20 pt-4 underline font-bold" @click="clickCancel()">
                                {{btnCancel}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";

import { CampaignType } from "@/helper/StaticValue.js";
//component
import DefaultConfirmRedeem from './component/DefaultConfirmRedeem.vue';
//feature
import { useLocale } from "@/feature/LocaleFeature"

export default {
    setup: function() {
        const { lbl } = useLocale()
        return {
            lbl,
        }
    },
    name: "ConfirmRedeemModal",
    components: {
        DefaultConfirmRedeem,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.iimmpact.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.iimmpact.confirm_redeem.cancel;
            }

            this.initialModal();
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },

        initialModal: function () {
            if (!this.campaign.delivered) {
                switch (this.campaign.type) {
                    case CampaignType.Interface:
                    case CampaignType.Free:
                    case CampaignType.Deal:
                        this.type = 'default';
                        break;
                }
            } else {
                return ;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "../../style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
